import { OrderType } from "@/types";
import { load } from "@cashfreepayments/cashfree-js";
import React, { createContext, useState, useContext } from "react";

const cashfreeEnv =
  process.env.NEXT_PUBLIC_CASHFREE_ENV === "production"
    ? "production"
    : "sandbox";

interface OrderContextType {
  createOrder: (orderDetails: OrderDetails) => Promise<void>;
}

type OrderDetails = {
  orderType: OrderType;
};

export const OrderContext = createContext<OrderContextType | undefined>(
  undefined
);

export const OrderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [creatingOrder, setCreatingOrder] = useState(false);
  const createOrder = async (orderDetails: OrderDetails) => {
    try {
      const { orderType } = orderDetails;
      if (creatingOrder) {
        return;
      }
      setCreatingOrder(true);
      try {
        const response = await fetch("/api/orders", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ orderType }),
        });
        const data = await response.json();
        console.log("Order created:", data);
        let checkoutOptions = {
          paymentSessionId: data.order.paymentSessionId,
          redirectTarget: "_self",
        };

        const cashfree = await load({
          mode: cashfreeEnv,
        });

        cashfree.checkout(checkoutOptions);
      } catch (error) {
        console.error("Error creating order:", error);
      } finally {
        setCreatingOrder(false);
        //   remove forward search params
      }
    } catch (error) {
      console.error("Failed to create order:", error);
    }
  };

  const value = {
    createOrder,
  };

  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
};

export const useOrder = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error("useOrder must be used within an OrderProvider");
  }
  return context;
};
